<div class="job-fulfillment-type-selector">
    @if (!editMode()) {
    <div>
        <span>{{viewModeText}}</span>
        @if (canEdit() && !editMode()) {
        <button class="edit-button" mat-icon-button color="primary" (click)="onEditClicked()">
            <mat-icon>edit</mat-icon>
        </button>
        }
    </div>
    } @else {
    <div class="select-container">
        <div class="multi-select">
            <mat-form-field appearance="outline" data-qa-id="jobFulfillmentTypeSelect">
                <mat-select [formControl]="selectedTypesControl" (selectionChange)="selectionsChangedEvent()" multiple>
                    <mat-select-trigger
                        class="job-fulfillment-type-selector-trigger">{{selectionsTriggerText}}</mat-select-trigger>
                    @for (type of availableTypes(); track type.id) {
                    <mat-option [value]="type.id" [disabled]="type.id === JobFulfillmentTypeEnum.DefaultWorkflow"
                        class="job-fulfillment-type-selector-option">
                        <div class="job-fulfillment-type-selector-option-content">
                            <span>{{type.name}}</span>
                            <mat-icon [novaMultiLineTooltip]="type.info">info</mat-icon>
                        </div>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <span class="nova__label">Default Fulfillment</span>
        <div class="default-select">
            <mat-form-field data-qa-id="defaultFulfillmentSelect">
                <mat-select [formControl]="defaultTypeControl" (selectionChange)="defaultSelectionChangedEvent()">
                    <mat-select-trigger
                        class="job-fulfillment-type-selector-trigger">{{defaultTriggerText}}</mat-select-trigger>
                    @for (type of availableDefaultTypes; track $index) {
                    <mat-option [value]="type.id" class="job-fulfillment-type-selector-option">
                        <div class="job-fulfillment-type-selector-option-content">
                            <span>{{type.name}}</span>
                            <mat-icon [novaMultiLineTooltip]="type.info">info</mat-icon>
                        </div>
                    </mat-option>
                    }
                </mat-select>
                @if (defaultTypeControl.hasError('required')) {
                <mat-error>You must make a
                    selection</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="edit-buttons-container">
            <button class="edit-button" data-qa-id="jobFulfillmentTypeSaveBtn" [disabled]="saveButtonDisabled" mat-icon-button color="primary"
                (click)="saveChanges()">
                <mat-icon>check_circle</mat-icon>
            </button>
            <button class="edit-button" data-qa-id="jobFulfillmentTypeCancelBtn" mat-icon-button color="primary" (click)="cancelEditMode()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    }
</div>